import { PropsWithClassNames } from "../../../structure";
import { Fonts } from "../../../structure/layout/font";

export interface IconProps extends PropsWithClassNames {
  name: IconName;
  color?: string;
  variant?: IconVariant;
  size?: number;
  onPress?: () => void;
  disabled?: boolean;
}

export type IconName =
  | "search"
  | "menu"
  | "home"
  | "check"
  | "check_circle"
  | "visibility"
  | "visibility_off"
  | "info"
  | "error"
  | "warning"
  | "cancel"
  | "check_box"
  | "check_box_outline_blank"
  | "radio_button_checked"
  | "radio_button_unchecked"
  | "arrow_back"
  | "arrow_back_ios"
  | "arrow_forward_ios"
  | "sports_and_outdoors"
  | "sports_soccer"
  | "logout"
  | "analytics"
  | "close"
  | "change_circle"
  | "trophy"
  | "reward_ads"
  | "emoji_events"
  | "keyboard_arrow_down"
  | "keyboard_arrow_up"
  | "navigate_next"
  | "calendar_month"
  | "sports_soccer"
  | "podiatry";

export type IconVariant = "outlined" | "rounded" | "sharp";

export const IconVariantMap: { [key in IconVariant]: Fonts } = {
  outlined: Fonts.IconsOutline,
  rounded: Fonts.IconsRound,
  sharp: Fonts.IconsSharp,
};
